import { render, staticRenderFns } from "./MediaFiliacionComponent.vue?vue&type=template&id=117f5077"
import script from "./MediaFiliacionComponent.vue?vue&type=script&lang=js"
export * from "./MediaFiliacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports